import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetSubCategory = createAsyncThunk(
  "subCategory/GetSubCategory",
  async (name, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.GETSUBCATEGORY}?query=${name}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetSubCategorySlice = createSlice({
  name: "AllSubCategory",
  initialState: {
    AllSubCategory: [],
    error: null,
  },
  reducers: {
    clearAllSubCategory: (state) => {
      state.AllSubCategory = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetSubCategory.fulfilled, (state, action) => {
        state.AllSubCategory = action.payload;
      })
      .addCase(GetSubCategory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearAllSubCategory } = GetSubCategorySlice.actions;
export default GetSubCategorySlice.reducer;
